import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function ManualLoadsContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="manualLoad" />
    </SceneMenuContent>
  );
}
